var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4145 1.22681C10.7489 1.60505 10.7489 2.1732 10.4145 2.55146L4.57964 9.15245C4.18164 9.6027 3.47923 9.60273 3.0812 9.15251L0.585576 6.32969C0.251167 5.95143 0.251167 5.38324 0.585576 5.00498L0.920945 4.62564C1.31896 4.17545 2.02132 4.17545 2.41933 4.62564L3.83045 6.22178L8.58068 0.847591C8.97867 0.397319 9.68109 0.397282 10.0791 0.847512L10.4145 1.22681Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.b6486603bd54f8916b55b03b4c7f8bdd.svg";
export { ForwardRef as ReactComponent };